/* eslint-disable */
export default {
    bind(el, binding, vnode) {
        vnode.context.$root.$on( 'bv::modal::shown', (evt) => {
            setTimeout(function() {
                var searchInterface = document.querySelector('.CoveoSearchInterface');
                if(searchInterface && window.Coveo && typeof window.Coveo !== 'undefined'){
                    window.Coveo.$$(searchInterface).on('newQuery', function(e){
                        vnode.context.$root.$emit('bv::hide::modal', 'coveomodal1');
                    });
                }
            }, 0);
        });
    }    
}


// WEBPACK FOOTER //
// ./src/app/directives/close-coveo-modal.js